<template>
  <section class="hero-split-section position-relative overflow-hidden" id="inicio">
    <!-- SVG Curva Divisoria Orgánica Estilo App FitGym (app_fitgyv2) -->
    <svg
      class="hero-app-curve pointer-events-none d-none d-lg-block"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
    >
      <defs>
        <linearGradient id="sageHalfGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#a3b8b5" style="stop-color: #a3b8b5; stop-opacity: 1;" />
          <stop offset="100%" stop-color="#889e9b" style="stop-color: #889e9b; stop-opacity: 1;" />
        </linearGradient>
      </defs>

      <path
        d="M 58 0 C 46 22, 38 40, 48 58 C 58 76, 42 90, 36 100 L 100 100 L 100 0 Z"
        fill="url(#sageHalfGrad)"
        style="fill: url(#sageHalfGrad);"
      />
    </svg>

    <!-- Patrón de verduras gourmet difuminado de fondo (cubre toda la sección) -->
    <div class="hero-veggies-layer"></div>

    <div class="container-fluid p-0 position-relative hero-content-container">
      <div class="row g-0 align-items-stretch">
        
        <!-- Columna Izquierda: Fondo Cálido con Textura de Ingredientes Frescos -->
        <div class="col-12 col-lg-6 hero-left-panel d-flex align-items-center justify-content-center p-4 p-md-5 position-relative">
          <div class="hero-content-box position-relative z-2">

            <!-- Título Principal Impactante -->
            <h1 class="hero-main-title roboto text-white mb-3">
              Comida real que nutre tus metas con <span class="highlight-orange">sabor gourmet</span>
            </h1>

            <!-- Subtítulo -->
            <p class="hero-description quicksand text-white mb-4">
              En <strong class="highlight-orange">The Fit Bar</strong> cocinamos cada platillo al momento con ingredientes 100% frescos, 
              balance de macronutrientes pesado y un toque culinario que hará de cada comida tu momento favorito del día.
            </p>

            <!-- Botones Duales de Acción -->
            <div class="mb-4">
              <a
                href="https://api.whatsapp.com/send?phone=9983641651&text=%C2%A1Hola%20The%20Fit%20Bar!%20%F0%9F%8D%BD%EF%B8%8F%20Quiero%20hacer%20un%20pedido%20a%20domicilio."
                target="_blank"
                rel="noopener noreferrer"
                class="btn btn-delivery-whatsapp d-inline-flex align-items-center gap-2"
              >
                <i class="bi bi-whatsapp fs-5"></i>
                <span>PEDIR POR WHATSAPP</span>
              </a>
            </div>
          </div>
        </div>

        <!-- Columna Derecha: Platillo Cenital sobre la Curva Orgánica Pastel -->
        <div class="col-12 col-lg-6 hero-right-panel p-4 p-md-5 d-flex align-items-center justify-content-center position-relative">
          
          <!-- Imagen Cenital del Platillo Estrella -->
          <div class="hero-dish-img-wrap text-center position-relative">
            <img
              :src="require('@/assets/img/portada.png')"
              alt="Platillo Gourmet The Fit Bar"
              class="img-fluid hero-dish-img"
            />
          </div>

        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Contenedor1",
};
</script>

<style scoped>
.hero-split-section {
    padding-top: 4.8rem;
    background: /* Capa de difuminado horizontal que elimina el corte y se funde suavemente con el fondo oscuro */ linear-gradient(to right, transparent 0%, transparent 40%, rgba(21, 24, 25, 0.3) 60%, rgba(21, 24, 25, 0.8) 85%, #151819 100%), /* Resplandor cálido de brasa */ radial-gradient(circle at 75% 50%, rgb(253 111 60 / 39%) 0%, rgba(230, 85, 35, 0.06) 45%, #942700 72%), /* Degradado cálido base */ linear-gradient(356deg, #fbad01e3 0%, #dc35457d 60%, #121415 100%);
    min-height: 560px;
    position: relative;
}

/* SVG Curva Orgánica Estilo App FitGym (app_fitgyv2) */
.hero-app-curve {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

.hero-app-curve path {
  filter: drop-shadow(-8px 0px 18px rgba(0, 0, 0, 0.5));
}

/* Contenedor de Contenido Principal con z-index superior a la curva y al patrón */
.hero-content-container {
  position: relative;
  z-index: 10;
}

/* Panel Izquierdo Culinario */
.hero-left-panel {
  background: transparent;
  min-height: 560px;
  position: relative;
  z-index: 11;
}

.hero-content-box {
  max-width: 540px;
  position: relative;
  z-index: 10;
}

.hero-tag-pill {
  background: rgba(253, 111, 60, 0.18);
  border: 1px solid rgba(253, 111, 60, 0.4);
}

.btn-delivery-whatsapp {
  background-color: #119542 !important;
  color: #ffffff !important;
  font-weight: 800;
  font-size: 1rem;
  padding: 14px 32px;
  border-radius: 14px;
  border: none;
  text-decoration: none;
  position: relative;
  z-index: 15;
  transition: all 0.3s ease;
}

.btn-delivery-whatsapp:hover {
  background-color: #1eb956 !important;
  color: #ffffff !important;
  transform: translateY(-2px);
  box-shadow: 0 12px 30px rgba(37, 211, 102, 0.6);
}

.pulse-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #fd6f3c;
  display: inline-block;
  box-shadow: 0 0 10px #fd6f3c;
}

.hero-tag-text {
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 1px;
  color: #fd6f3c;
}

.hero-main-title {
  font-size: 2.85rem;
  line-height: 1.15;
  font-weight: 900;
}

.highlight-orange {
  color: #fd6f3c;
  position: relative;
}

.hero-description {
  font-size: 1.1rem;
  line-height: 1.6;
}

.hero-mini-badge {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #ffffff;
  padding: 6px 14px;
  border-radius: 30px;
  font-size: 0.8rem;
  font-weight: 600;
}

.text-naranja {
  color: #fd6f3c !important;
}

.btn-hero-primary {
  background-color: #fd6f3c;
  color: #ffffff;
  border: none;
  font-weight: 800;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  padding: 13px 28px;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(253, 111, 60, 0.4);
  transition: all 0.3s ease;
}

.btn-hero-primary:hover {
  background-color: #e55928;
  color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 12px 30px rgba(253, 111, 60, 0.55);
}

.btn-hero-secondary {
  background-color: transparent;
  color: #ffffff;
  border: 1.5px solid rgba(255, 255, 255, 0.4);
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  padding: 13px 26px;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.btn-hero-secondary:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: #ffffff;
  color: #ffffff;
  transform: translateY(-2px);
}



/* Panel Derecho: Transparente para dejar lucir la curva SVG */
.hero-right-panel {
  background: transparent;
  min-height: 560px;
  position: relative;
  z-index: 11;
}

/* Capa de Patrón de Verduras Frescas / Ingredientes Culinarios */
.hero-veggies-layer {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 2;
  background-image: url('~@/assets/img/pattern_verduras_blanco.png');
  background-repeat: repeat;
  background-size: 640px auto;
  opacity: 0.28;
  mix-blend-mode: overlay;
}

.hero-dish-img-wrap {
  width: 100%;
  max-width: 440px;
  position: relative;
  z-index: 15;
}

.hero-dish-img {
  filter: drop-shadow(0 20px 35px rgba(0, 0, 0, 0.3));
  transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  display: block;
  margin: 0 auto;
}

.hero-dish-img:hover {
  transform: scale(1.04) rotate(1deg);
}

/* Tarjeta Flotante Tipo Receta */
.floating-recipe-card {
  position: absolute;
  bottom: 24px;
  right: 24px;
  max-width: 310px;
  z-index: 10;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.25) !important;
  animation: floatCard 4s ease-in-out infinite alternate;
}

@keyframes floatCard {
  0% { transform: translateY(0px); }
  100% { transform: translateY(-6px); }
}

.recipe-avatar {
  width: 36px;
  height: 36px;
  border: 2px solid #fd6f3c;
}

.star-rating-line {
  font-size: 0.72rem;
}

.recipe-dish-name {
  font-size: 0.95rem;
}

.recipe-dish-desc {
  font-size: 0.76rem;
  line-height: 1.35;
}

.badge-macros-mini {
  font-size: 0.75rem;
  font-weight: 700;
  color: #fd6f3c;
  background: #fff3ee;
  padding: 3px 8px;
  border-radius: 6px;
}

.btn-recipe-action {
  background-color: #fd6f3c;
  color: #fff;
  font-weight: 700;
  font-size: 0.75rem;
  transition: all 0.2s ease;
}

.btn-recipe-action:hover {
  background-color: #e55928;
  color: #fff;
}

.citrus-accent-float {
  position: absolute;
  top: 15px;
  left: 20px;
  font-size: 2.2rem;
  filter: drop-shadow(0 8px 15px rgba(0, 0, 0, 0.2));
  animation: floatCitrus 5s ease-in-out infinite alternate;
}

@keyframes floatCitrus {
  0% { transform: translateY(0px) rotate(0deg); }
  100% { transform: translateY(-8px) rotate(10deg); }
}

/* Bowl Decorativo Flotante Disperso (Pechuga & Camote) */
.floating-bowl-decor {
  position: absolute;
  z-index: 10;
  pointer-events: none;
  filter: drop-shadow(0 15px 25px rgba(0, 0, 0, 0.65));
}

.bowl-hero {
  bottom: 20px;
  right: clamp(15px, 3vw, 45px);
  animation: floatBowlHero 6s ease-in-out infinite alternate;
}

.floating-bowl-img {
  width: 195px;
  height: 195px;
  object-fit: contain;
  transform: rotate(-10deg);
  transition: transform 0.3s ease;
}

.bowl-label-mini {
  background: rgba(15, 18, 20, 0.88);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(253, 111, 60, 0.4);
  color: #fff;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 3px 12px;
  border-radius: 20px;
  text-align: center;
  margin-top: -8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  white-space: nowrap;
}

@keyframes floatBowlHero {
  0% { transform: translateY(0) rotate(0deg); }
  100% { transform: translateY(-16px) rotate(-3deg); }
}

@media (max-width: 991px) {
  .hero-split-section {
    background: 
      radial-gradient(circle at 75% 50%, rgb(253 111 60 / 39%) 0%, rgba(230, 85, 35, 0.06) 45%, #fd6f3cb0 72%),
      linear-gradient(356deg, #fbad01e3 0%, #dc35457d 60%, #121415 100%);
  }
  .hero-main-title {
    font-size: 2.1rem;
  }
  .hero-left-panel {
    min-height: auto;
    padding-bottom: 2rem !important;
  }
  .hero-right-panel {
    background: linear-gradient(145deg, #a3b8b5 0%, #889e9b 100%);
    border-radius: 40px 40px 0 0;
    min-height: 460px;
    padding: 2.5rem 1.5rem !important;
    box-shadow: 0 -15px 35px rgba(0, 0, 0, 0.25);
  }
  .floating-recipe-card {
    position: static;
    margin-top: 1.5rem;
    max-width: 100%;
  }
}
</style>
